<template>
  <div>
    <div class="flex">
      <div>
        <br />
        <table class="reciept-table">
          <thead>
            <tr>
              <th>Настройка</th>
              <th>Значение</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Токен Telegram-бота родителей</td>
              <td>
                <input
                  type="text"
                  id="token"
                  style="width: 400px"
                  class="form-control"
                  required
                  v-model="tokenTelegramBot"
                />
              </td>
              <td>
                <button
                  v-if="!checkCreateToken"
                  @click="createTokenTelegramBot()"
                  id="createReciept"
                  class="btn btn-primary"
                  style="padding: 0 0 0 0; margin: 0 0 0 0"
                >
                  Создать токен
                </button>
                <button
                  v-if="checkCreateToken"
                  @click="updateTokenTelegramBot()"
                  id="createReciept"
                  class="btn btn-primary"
                  style="padding: 0 0 0 0; margin: 0 0 0 0"
                >
                  Обновить токен
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="reciept-table">
          <tr>
            <th>Наименование</th>
            <th>Значение</th>
            <th>Действие</th>
          </tr>
          <tr>
            <td>Учебный год</td>
            <td>
              <select class="form-select" v-model="year_act" name="" id="">
                <option value="2023_2024">2023-2024</option>
                <option value="2024_2025">2024-2025</option>
                <option value="2025_2026">2025-2026</option>
                <option value="2026_2027">2026-2027</option>
              </select>
            </td>
            <td>
              <button class="btn btn-primary" @click="goToURL()">
                Поменять год
              </button>
            </td>
          </tr>
        </table>

        <!-- Новая секция: Управление базами данных -->
        <table class="reciept-table" style="margin-top: 20px">
          <thead>
            <tr>
              <th
                colspan="3"
                style="text-align: center; background-color: #f8f9fa"
              >
                <strong>Управление базами данных</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3" style="text-align: center">
                <button
                  @click="openCopyDbModal"
                  class="btn btn-info"
                  style="margin-right: 10px; padding: 8px 20px"
                  :disabled="isLoading"
                >
                  <i class="fas fa-copy"></i> Копировать БД
                </button>
                <button
                  @click="openRestoreDbModal"
                  class="btn btn-warning"
                  style="padding: 8px 20px"
                  :disabled="isLoading"
                >
                  <i class="fas fa-undo"></i> Восстановить из копии
                </button>
              </td>
            </tr>
            <tr v-if="databases.length > 0">
              <td colspan="3" style="padding: 10px">
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                    justify-content: center;
                  "
                >
                  <span
                    v-for="db in databases"
                    :key="db"
                    class="db-badge"
                    :class="{ 'current-db': db === currentDbName }"
                  >
                    {{ db }}
                    <span
                      v-if="db === currentDbName"
                      style="font-size: 12px; margin-left: 5px; color: #fff"
                      >(текущая)</span
                    >
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Модальное окно для копирования БД -->
    <div v-if="showCopyModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Создание копии базы данных</h3>
          <button class="close-btn" @click="closeModal">×</button>
        </div>

        <div class="modal-body">
          <!-- Результаты -->
          <div v-if="showResults && copyResults" style="margin-bottom: 20px">
            <div
              class="alert"
              :class="copyResults.success ? 'alert-success' : 'alert-warning'"
            >
              <strong>{{ copyResults.message }}</strong>
              <p>Скопировано документов: {{ copyResults.totalCopied }}</p>
            </div>

            <table class="result-table">
              <thead>
                <tr>
                  <th>Коллекция</th>
                  <th>Статус</th>
                  <th>Документов</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="result in copyResults.results"
                  :key="result.collection"
                >
                  <td>{{ result.collection }}</td>
                  <td>
                    <span v-if="result.success" style="color: #28a745"
                      >✓ {{ result.message }}</span
                    >
                    <span v-else style="color: #dc3545"
                      >✗ {{ result.error }}</span
                    >
                  </td>
                  <td>{{ result.copied || 0 }}</td>
                </tr>
              </tbody>
            </table>

            <div style="margin-top: 15px; text-align: center">
              <button class="btn btn-success" @click="closeModal">
                Готово
              </button>
            </div>
          </div>

          <!-- Форма копирования -->
          <div v-if="!showResults">
            <!-- Выбор исходной БД -->
            <div class="form-group" style="margin-bottom: 15px">
              <label for="sourceDbNameCopy"
                ><strong>Выберите базу данных для копирования:</strong></label
              >
              <select
                id="sourceDbNameCopy"
                class="form-select"
                v-model="copySourceDbName"
                @change="onCopySourceDbChange"
                style="margin-top: 5px"
              >
                <option value="">Выберите БД...</option>
                <option v-for="db in existingDatabases" :key="db" :value="db">
                  {{ db }} {{ db === currentDbName ? "(текущая)" : "" }}
                </option>
              </select>
              <small style="color: #6c757d"
                >Выберите базу данных, которую нужно скопировать</small
              >
            </div>

            <!-- Имя новой БД -->
            <div class="form-group" style="margin-bottom: 15px">
              <label for="newDbName"
                ><strong>Имя новой базы данных:</strong></label
              >
              <input
                type="text"
                id="newDbName"
                class="form-control"
                v-model="newDbName"
                placeholder="Введите имя новой БД"
                style="margin-top: 5px"
              />
              <small style="color: #6c757d">Пример: schoolDB_backup_2024</small>
            </div>

            <!-- Коллекции -->
            <div style="margin: 15px 0">
              <p><strong>Выберите коллекции для копирования:</strong></p>

              <div
                v-if="isLoadingCollections"
                style="text-align: center; padding: 20px"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                ></span>
                Загрузка коллекций...
              </div>

              <div
                v-else-if="
                  availableCollections.length === 0 && copySourceDbName
                "
                style="text-align: center; padding: 20px; color: #6c757d"
              >
                В выбранной базе данных нет коллекций
              </div>

              <div v-else>
                <div
                  style="
                    margin: 10px 0;
                    padding: 10px;
                    background: #f8f9fa;
                    border-radius: 4px;
                  "
                >
                  <label style="cursor: pointer">
                    <input
                      type="checkbox"
                      @change="toggleAllCollections"
                      :checked="
                        selectedCollections.length ===
                          availableCollections.length &&
                        availableCollections.length > 0
                      "
                    />
                    <strong style="margin-left: 5px">Выбрать все</strong>
                  </label>
                </div>

                <div
                  v-for="col in availableCollections"
                  :key="col"
                  style="
                    margin: 8px 0;
                    padding: 5px 10px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #e9ecef;
                  "
                >
                  <label
                    style="cursor: pointer; display: flex; align-items: center"
                  >
                    <input
                      type="checkbox"
                      v-model="selectedCollections"
                      :value="col"
                    />
                    <span style="margin-left: 8px">{{ col }}</span>
                  </label>
                </div>

                <div style="margin-top: 10px; color: #6c757d; font-size: 14px">
                  Выбрано: <strong>{{ selectedCollections.length }}</strong> из
                  <strong>{{ availableCollections.length }}</strong>
                </div>
              </div>
            </div>

            <!-- Существующие БД -->
            <div
              v-if="existingDatabases.length > 0"
              style="
                margin: 15px 0;
                padding: 10px;
                background: #f8f9fa;
                border-radius: 4px;
              "
            >
              <p style="margin-bottom: 8px">
                <strong>Существующие базы данных:</strong>
              </p>
              <div style="display: flex; flex-wrap: wrap; gap: 5px">
                <span
                  v-for="db in existingDatabases"
                  :key="db"
                  class="db-badge-small"
                  :class="{ 'db-exists': db === newDbName.trim() }"
                >
                  {{ db }}
                  <span v-if="db === newDbName.trim()" style="color: #856404"
                    >⚠️</span
                  >
                </span>
              </div>
              <div
                v-if="
                  newDbName.trim() &&
                  existingDatabases.includes(newDbName.trim())
                "
                style="margin-top: 8px; color: #856404; font-size: 14px"
              >
                ⚠️ База данных с таким именем уже существует. При копировании
                она будет перезаписана.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer" v-if="!showResults">
          <button
            class="btn btn-secondary"
            @click="closeModal"
            :disabled="isLoading"
          >
            Отмена
          </button>
          <button
            class="btn btn-primary"
            @click="copyDatabase"
            :disabled="
              isLoading ||
              !copySourceDbName ||
              !newDbName.trim() ||
              selectedCollections.length === 0
            "
          >
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm"
              role="status"
            ></span>
            {{ isLoading ? " Копирование..." : " Создать копию" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Модальное окно для восстановления -->
    <div v-if="showRestoreModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Восстановление базы данных из копии</h3>
          <button class="close-btn" @click="closeModal">×</button>
        </div>

        <div class="modal-body">
          <!-- Результаты -->
          <div v-if="showResults && restoreResults" style="margin-bottom: 20px">
            <div
              class="alert"
              :class="
                restoreResults.success ? 'alert-success' : 'alert-warning'
              "
            >
              <strong>{{ restoreResults.message }}</strong>
              <p>
                Восстановлено документов: {{ restoreResults.totalRestored }}
              </p>
            </div>

            <table class="result-table">
              <thead>
                <tr>
                  <th>Коллекция</th>
                  <th>Статус</th>
                  <th>Документов</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="result in restoreResults.results"
                  :key="result.collection"
                >
                  <td>{{ result.collection }}</td>
                  <td>
                    <span v-if="result.success" style="color: #28a745"
                      >✓ {{ result.message }}</span
                    >
                    <span v-else style="color: #dc3545"
                      >✗ {{ result.error }}</span
                    >
                  </td>
                  <td>{{ result.restored || 0 }}</td>
                </tr>
              </tbody>
            </table>

            <div style="margin-top: 15px; text-align: center">
              <button class="btn btn-success" @click="closeModal">
                Готово
              </button>
            </div>
          </div>

          <!-- Форма восстановления -->
          <div v-if="!showResults">
            <div class="form-group" style="margin-bottom: 15px">
              <label for="sourceDbName"
                ><strong
                  >Выберите базу данных для восстановления:</strong
                ></label
              >
              <select
                id="sourceDbName"
                class="form-select"
                v-model="sourceDbName"
                @change="onSourceDbChange"
                style="margin-top: 5px"
              >
                <option value="">Выберите БД...</option>
                <option
                  v-for="db in existingDatabases"
                  :key="db"
                  :value="db"
                  :disabled="db === currentDbName"
                >
                  {{ db }} {{ db === currentDbName ? "(текущая)" : "" }}
                </option>
              </select>
              <small style="color: #6c757d"
                >Выберите базу данных, из которой нужно восстановить
                данные</small
              >
            </div>

            <div style="margin: 15px 0">
              <p><strong>Выберите коллекции для восстановления:</strong></p>

              <div
                v-if="isLoadingRestoreCollections"
                style="text-align: center; padding: 20px"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                ></span>
                Загрузка коллекций...
              </div>

              <div
                v-else-if="
                  restoreAvailableCollections.length === 0 && sourceDbName
                "
                style="text-align: center; padding: 20px; color: #6c757d"
              >
                В выбранной базе данных нет коллекций
              </div>

              <div v-else>
                <div
                  style="
                    margin: 10px 0;
                    padding: 10px;
                    background: #f8f9fa;
                    border-radius: 4px;
                  "
                >
                  <label style="cursor: pointer">
                    <input
                      type="checkbox"
                      @change="toggleAllRestoreCollections"
                      :checked="
                        restoreCollections.length ===
                          restoreAvailableCollections.length &&
                        restoreAvailableCollections.length > 0
                      "
                    />
                    <strong style="margin-left: 5px">Выбрать все</strong>
                  </label>
                </div>

                <div
                  v-for="col in restoreAvailableCollections"
                  :key="col"
                  style="
                    margin: 8px 0;
                    padding: 5px 10px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #e9ecef;
                  "
                >
                  <label
                    style="cursor: pointer; display: flex; align-items: center"
                  >
                    <input
                      type="checkbox"
                      v-model="restoreCollections"
                      :value="col"
                    />
                    <span style="margin-left: 8px">{{ col }}</span>
                  </label>
                </div>

                <div style="margin-top: 10px; color: #6c757d; font-size: 14px">
                  Выбрано: <strong>{{ restoreCollections.length }}</strong> из
                  <strong>{{ restoreAvailableCollections.length }}</strong>
                </div>
              </div>
            </div>

            <div
              style="
                margin: 15px 0;
                padding: 10px;
                background: #fff3cd;
                border-radius: 4px;
                border: 1px solid #ffeeba;
              "
            >
              <p style="margin: 0; color: #856404">
                ⚠️ Внимание! Восстановление перезапишет выбранные коллекции в
                текущей базе данных.
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer" v-if="!showResults">
          <button
            class="btn btn-secondary"
            @click="closeModal"
            :disabled="isLoading"
          >
            Отмена
          </button>
          <button
            class="btn btn-warning"
            @click="restoreDatabase"
            :disabled="
              isLoading || !sourceDbName || restoreCollections.length === 0
            "
          >
            <span
              v-if="isLoading"
              class="spinner-border spinner-border-sm"
              role="status"
            ></span>
            {{ isLoading ? " Восстановление..." : " Восстановить" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServerCommandLogin from "../services/ServerCommandLogin";
import TutorialDataService from "../services/TutorialDataService";

export default {
  data() {
    return {
      // Существующие данные
      tokenTelegramBot: "",
      checkCreateToken: false,
      year_act: "",

      // Новые данные для управления БД
      showCopyModal: false,
      showRestoreModal: false,

      // Для копирования
      copySourceDbName: "", // Исходная БД для копирования
      newDbName: "",
      availableCollections: [],
      selectedCollections: [],
      isLoadingCollections: false,

      // Для восстановления
      sourceDbName: "",
      restoreAvailableCollections: [],
      restoreCollections: [],
      isLoadingRestoreCollections: false,

      // Общие
      existingDatabases: [],
      databases: [],
      currentDbName: "schoolDB",
      copyResults: null,
      restoreResults: null,
      showResults: false,
      isLoading: false,
    };
  },
  methods: {
    // Существующие методы
    async createTokenTelegramBot() {
      let data = { token: this.tokenTelegramBot };
      await TutorialDataService.createTelegramToken(data)
        .then((res) => {
          console.log(res);
          alert("Успешно");
        })
        .catch((e) => {
          console.log("1111111111", e);
        });
    },
    async updateTokenTelegramBot() {
      let data = { token: this.tokenTelegramBot };
      await TutorialDataService.updateTelegramToken(data)
        .then((res) => {
          console.log(res);
          alert("Успешно");
        })
        .catch((e) => {
          console.log("1111111111", e);
        });
    },
    async getTokenTelegramBot() {
      await TutorialDataService.getTelegramToken()
        .then((res) => {
          this.tokenTelegramBot = res.data;
          console.log(res.data);
          if (String(res.data).length > 0) {
            this.checkCreateToken = true;
          }
        })
        .catch((e) => {
          console.log("1111111111", e);
        });
    },
    async goToURL() {
      window.myVariable = process.env.VUE_APP_URL_SERVER;
      const fullUrl = window.myVariable;
      const urlObj = new URL(fullUrl);
      const baseUrl = `${urlObj.protocol}//${urlObj.host}/`;
      console.log(baseUrl);
      window.myVariable = baseUrl + "tutorials/" + this.year_act;
      console.log(window.myVariable);
      ServerCommandLogin.updateAxiosInstance();
      alert("Год был изменен!");
      console.log(window.myVariable);
    },

    // Новые методы для управления БД
    async loadData() {
      await this.getDatabases();
    },

    async getDatabases() {
      try {
        const response = await TutorialDataService.getDatabases();
        if (response.data.success) {
          this.databases = response.data.databases;
          this.existingDatabases = response.data.databases;
          // Устанавливаем текущую БД по умолчанию для копирования
          if (!this.copySourceDbName && this.databases.length > 0) {
            this.copySourceDbName = this.currentDbName;
          }
        }
      } catch (error) {
        console.error("Ошибка получения списка БД:", error);
        alert("Ошибка получения списка баз данных");
      }
    },

    async getCollections(dbName) {
      if (!dbName) return;

      this.isLoadingCollections = true;
      try {
        const response = await TutorialDataService.getCollections(dbName);
        if (response.data.success) {
          this.availableCollections = response.data.collections;
          // По умолчанию выбираем все коллекции
          this.selectedCollections = [...response.data.collections];
        }
      } catch (error) {
        console.error("Ошибка получения списка коллекций:", error);
        alert("Ошибка получения списка коллекций");
        this.availableCollections = [];
        this.selectedCollections = [];
      } finally {
        this.isLoadingCollections = false;
      }
    },

    async getRestoreCollections() {
      if (!this.sourceDbName) return;

      this.isLoadingRestoreCollections = true;
      try {
        const response = await TutorialDataService.getCollections(
          this.sourceDbName,
        );
        if (response.data.success) {
          this.restoreAvailableCollections = response.data.collections;
          this.restoreCollections = [...response.data.collections];
        }
      } catch (error) {
        console.error(
          "Ошибка получения списка коллекций для восстановления:",
          error,
        );
        alert("Ошибка получения списка коллекций");
        this.restoreAvailableCollections = [];
        this.restoreCollections = [];
      } finally {
        this.isLoadingRestoreCollections = false;
      }
    },

    // При изменении исходной БД для копирования
    onCopySourceDbChange() {
      this.selectedCollections = [];
      this.availableCollections = [];
      if (this.copySourceDbName) {
        this.getCollections(this.copySourceDbName);
      }
    },

    // При изменении исходной БД для восстановления
    onSourceDbChange() {
      this.restoreCollections = [];
      this.restoreAvailableCollections = [];
      if (this.sourceDbName) {
        this.getRestoreCollections();
      }
    },

    openCopyDbModal() {
      alert(
        "Внимание! Данная функция предназначена исключительно для администратора системы!",
      );
      this.showCopyModal = true;
      this.showResults = false;
      this.copyResults = null;
      this.newDbName = "";
      this.selectedCollections = [];
      this.availableCollections = [];
      // Устанавливаем текущую БД по умолчанию
      if (this.databases.length > 0) {
        this.copySourceDbName = this.currentDbName;
        this.getCollections(this.currentDbName);
      }
      this.loadData();
    },

    openRestoreDbModal() {
      alert(
        "Внимание! Данная функция предназначена исключительно для администратора системы!",
      );
      this.showRestoreModal = true;
      this.showResults = false;
      this.restoreResults = null;
      this.sourceDbName = "";
      this.restoreCollections = [];
      this.restoreAvailableCollections = [];
      this.loadData();
    },

    async copyDatabase() {
      if (!this.copySourceDbName) {
        alert("Выберите базу данных для копирования");
        return;
      }

      if (!this.newDbName.trim()) {
        alert("Введите имя для новой базы данных");
        return;
      }

      if (this.selectedCollections.length === 0) {
        alert("Выберите хотя бы одну коллекцию для копирования");
        return;
      }

      if (this.existingDatabases.includes(this.newDbName.trim())) {
        if (
          !confirm(
            `База данных "${this.newDbName}" уже существует. Перезаписать?`,
          )
        ) {
          return;
        }
      }

      this.isLoading = true;

      try {
        const response = await TutorialDataService.copyDatabase({
          sourceDbName: this.copySourceDbName,
          targetDbName: this.newDbName.trim(),
          collections: this.selectedCollections,
        });

        this.copyResults = response.data;
        this.showResults = true;
        await this.getDatabases();

        if (!response.data.success) {
          alert(
            "Некоторые коллекции не были скопированы. Проверьте результаты.",
          );
        }
      } catch (error) {
        console.error("Ошибка копирования БД:", error);
        alert("Ошибка при копировании базы данных");
      } finally {
        this.isLoading = false;
      }
    },

    async restoreDatabase() {
      if (!this.sourceDbName) {
        alert("Выберите базу данных для восстановления");
        return;
      }

      if (this.restoreCollections.length === 0) {
        alert("Выберите хотя бы одну коллекцию для восстановления");
        return;
      }

      if (
        !confirm(
          `Восстановить выбранные коллекции из базы "${this.sourceDbName}" в текущую базу?`,
        )
      ) {
        return;
      }

      this.isLoading = true;

      try {
        const response = await TutorialDataService.restoreDatabase({
          sourceDbName: this.sourceDbName,
          collections: this.restoreCollections,
        });

        this.restoreResults = response.data;
        this.showResults = true;

        if (!response.data.success) {
          alert(
            "Некоторые коллекции не были восстановлены. Проверьте результаты.",
          );
        }
      } catch (error) {
        console.error("Ошибка восстановления БД:", error);
        alert("Ошибка при восстановлении базы данных");
      } finally {
        this.isLoading = false;
      }
    },

    toggleAllCollections() {
      if (
        this.selectedCollections.length === this.availableCollections.length
      ) {
        this.selectedCollections = [];
      } else {
        this.selectedCollections = [...this.availableCollections];
      }
    },

    toggleAllRestoreCollections() {
      if (
        this.restoreCollections.length ===
        this.restoreAvailableCollections.length
      ) {
        this.restoreCollections = [];
      } else {
        this.restoreCollections = [...this.restoreAvailableCollections];
      }
    },

    closeModal() {
      this.showCopyModal = false;
      this.showRestoreModal = false;
      this.showResults = false;
      this.isLoading = false;
    },
  },
  async mounted() {
    await this.getTokenTelegramBot();
    await this.loadData();
  },
};
</script>

<style scoped>
/* Существующие стили */
.reciept-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.reciept-table th,
.reciept-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: left;
}

.reciept-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

/* Новые стили для модальных окон */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 700px;
  width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s;
}

.btn:hover:not(:disabled) {
  opacity: 0.9;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-info {
  background-color: #17a2b8;
  color: white;
}

.result-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.result-table th,
.result-table td {
  border: 1px solid #dee2e6;
  padding: 10px;
  text-align: left;
}

.result-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.alert {
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}

.db-badge {
  display: inline-block;
  padding: 6px 12px;
  background: #e9ecef;
  border-radius: 20px;
  font-size: 14px;
  color: #495057;
}

.db-badge.current-db {
  background: #007bff;
  color: white;
}

.db-badge-small {
  display: inline-block;
  padding: 4px 10px;
  background: #e9ecef;
  border-radius: 15px;
  font-size: 13px;
  color: #495057;
  margin: 2px;
}

.db-badge-small.db-exists {
  background: #fff3cd;
  border: 1px solid #ffc107;
}

.form-control {
  display: block;
  width: 100%;
  padding: 8px 12px;
  font-size: 16px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.form-select {
  display: block;
  width: 100%;
  padding: 8px 12px;
  font-size: 16px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: white;
}

.spinner-border {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner 0.75s linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.modal-body::-webkit-scrollbar {
  width: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
